module.exports = __WEBPACK_EXTERNAL_MODULE_47__;


//////////////////
// WEBPACK FOOTER
// external {"umd":"Vue","global":"Vue","root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 47
// module chunks = 0